import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ChatConversation from '../../chatView/components/ChatConversation';
import SubPageHeader from '../../components/molecules/SubPageHeader';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import ContextEnvSelect from '../../chatView/components/ContextEnvSelect';
import { getAdminModeEnabled } from '../../selectors/user';
import css from './RcaView.css';

const RcaView = ({ chat, onBack, contextEnv, onContextEnvChange }) => {
    const isAdminMode = useSelector(getAdminModeEnabled);
    const [showSessionDebug, setShowSessionDebug] = useState(false);

    return (
        <div className={css.rcaView}>
            <SubPageHeader
                labelTranslationKey="STATIC.PAGES.ANOMALY_ANALYSIS.INVESTIGATION_TITLE"
                onGoBack={onBack}
                className={css.header}
                rightSection={
                    isAdminMode ? (
                        <div className={css.headerActions}>
                            <ContextEnvSelect selectedEnv={contextEnv} onChange={onContextEnvChange} />
                            <Icon
                                name="bug"
                                size={IconSizes.MEDIUM}
                                variant={showSessionDebug ? IconVariants.ACTIVE : IconVariants.DARK}
                                onClick={() => setShowSessionDebug(open => !open)}
                                hoverText="STATIC.PAGES.ANALYSIS_CHAT.SESSION_DEBUG_HOVER"
                            />
                        </div>
                    ) : null
                }
            />
            <ChatConversation
                chat={chat}
                showSessionDebug={showSessionDebug}
                onSessionDebugClose={() => setShowSessionDebug(false)}
            />
        </div>
    );
};

RcaView.propTypes = {
    chat: PropTypes.shape({
        messages: PropTypes.arrayOf(PropTypes.object).isRequired,
        currentSessionId: PropTypes.string,
    }).isRequired,
    onBack: PropTypes.func.isRequired,
    contextEnv: PropTypes.string,
    onContextEnvChange: PropTypes.func,
};

export default RcaView;
